import { useDispatch, useSelector } from "react-redux";
import dynamicfunction from "../../utils/dynamicfunction";
import { useEffect, useState } from "react";
import { getContentKeyAccToLang } from "../../utils/utils";
import {
  getInvestmentReport,
  getInvestmentReportDropdown,
} from "../../store/actions/settingAction";

export default () => {
  const dispatch = useDispatch();
  const { TextWeight, isArabic } = dynamicfunction();
  const { reportsContent } = useSelector((state) => state.content);
  const { investmentDropdown, settingLoading, investmentReport } = useSelector((state) => state.setting);

  const [termsModal, setTermsModal] = useState(false);
  const [selectedDate, setSelectedDate] = useState(null);

  useEffect(() => {
    dispatch(getInvestmentReportDropdown());
  }, []);

  const getContentKey = (key) => {
    return getContentKeyAccToLang(
      reportsContent?.web_investment_report?.data?.attributes,
      key,
      isArabic
    );
  };

  const onPressSubmit = (values) => {
    setSelectedDate(`${values?.year?.year}-${values?.month?.key}-01`);

    const params = `?AssetId=${values?.asset_class?.id}&ReportTypeId=${values?.report_type?.id}&ProductId=${values?.product?.id}&Period=${values?.month?.key + '-' + values?.year?.year}`
    dispatch(getInvestmentReport(params));
  };

  const onPressEmail = () => {
    const apiData = {
      reportName: investmentReport?.title,
      date: selectedDate,
    };
  }

  return {
    isArabic,
    TextWeight,
    investmentDropdown,
    getContentKey,
    onPressSubmit,
    settingLoading,
    investmentReport,
    termsModal,
    setTermsModal,
    onPressEmail,
  };
};
